import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { ScrBaseComponent } from "src/app/components/base.component";
import { IScrBaseResponse } from "src/app/services";
import { MbOptOutSuccessUpdateEvent} from "../common-events";

@Component({
  selector: 'app-common-mb-opt-out-success',
  templateUrl: './mb-opt-out-success.component.html'
})
export class MbOptOutSuccessComponent extends ScrBaseComponent implements OnInit {

  public trackingNumberValue = "";
  public heading = "Opt Out of Monthly Billing";

  isDisabled = false;
  

  activeModal='';
  resp !: IScrBaseResponse;

  constructor() {
    super();
  }

  @Input() scId!: number;
  @Input() message!: string;
  @Input() leaseId!: number;
  @Input() user!: string;
  @Input() expirationDate?: Date | string;
  @Input() monthly_invoice_id?: number;
  @Input() invoice_date?: string;
  @Output() successUpdate = new EventEmitter<MbOptOutSuccessUpdateEvent>();


  ngOnInit() {
    this.isDisabled = false;
    if(this.user === 'sdUser')
     this.heading = `MB Opt-Out for Short Code ${this.scId}`;
  }

  onCancel = () => {
    this.activeModal = '';
    this.successUpdate.emit({isCompleted: false});
  };

  onSuccess = () => {
    this.activeModal = '';
    this.successUpdate.emit({isCompleted: true, response: this.resp});
  };

}
